"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("../Card"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _alignmentTypes = _interopRequireDefault(require("../../../../constants/alignmentTypes"));

var _iconNames = _interopRequireDefault(require("../../../../constants/iconNames"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _card = require("../../../../styles/2_commonComponentStyles/card");

var _IconCard = require("./IconCard.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The icon card captures a common layout that presents a themed card with a matching icon.
 *
 * **padding on first and last children are automatically stripped in an effort to normalize formatting**
 */
var IconCard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IconCard, _React$PureComponent);

  var _super = _createSuper(IconCard);

  function IconCard() {
    var _this;

    _classCallCheck(this, IconCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "iconMappings", {
      primary: 'info-circle',
      cta: 'info-circle',
      info: 'info-circle',
      warning: 'exclamation-circle',
      danger: 'exclamation-circle'
    });

    return _this;
  }

  _createClass(IconCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          colorTheme = _this$props.colorTheme,
          dataTestId = _this$props.dataTestId,
          iconName = _this$props.iconName,
          noBorder = _this$props.noBorder,
          noGhost = _this$props.noGhost,
          textAlign = _this$props.textAlign,
          withShadow = _this$props.withShadow;
      return /*#__PURE__*/_react.default.createElement(_Card.default, {
        className: className,
        colorTheme: noGhost ? colorTheme : "".concat(colorTheme, "Ghost"),
        dataTestId: dataTestId,
        noBorder: noBorder,
        textAlign: textAlign,
        withShadow: withShadow
      }, /*#__PURE__*/_react.default.createElement(_IconCard.InlineTopAlignWrapper, null, /*#__PURE__*/_react.default.createElement(_IconCard.IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        colorTheme: noGhost ? 'overDark' : colorTheme,
        dataTestId: "icon-card-icon",
        iconName: iconName || this.iconMappings[colorTheme]
      })), /*#__PURE__*/_react.default.createElement(_IconCard.ContentWrapper, {
        noGhost: noGhost
      }, children)));
    }
  }]);

  return IconCard;
}(_react.default.PureComponent);

_defineProperty(IconCard, "propTypes", {
  /** Content */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Color theme for the card
   * - use base values such as 'primary' or 'cta' and they will get mapped to the lighter ghost versions.
   * Defaults to info as that is the most common use.
  */
  colorTheme: _propTypes.default.oneOf(_card.ghostThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** IconName - hook to override the default icon for a given card type */
  iconName: _propTypes.default.oneOf(_iconNames.default),

  /** Flag for overriding application of the border which is turned off by default */
  noBorder: _propTypes.default.bool,

  /** by default the ghost style is used - this flag will disable that */
  noGhost: _propTypes.default.bool,

  /** alignment of header and content */
  textAlign: _propTypes.default.oneOf(_alignmentTypes.default),

  /** Flag to enable a drop shadow */
  withShadow: _propTypes.default.bool
});

_defineProperty(IconCard, "defaultProps", {
  className: '',
  colorTheme: 'info',
  iconName: undefined,
  noBorder: true,
  noGhost: false,
  textAlign: 'left',
  withShadow: false
});

var _default = IconCard;
exports.default = _default;